var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRaiseHand = function SvgRaiseHand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.542 14.191a.8.8 0 0 1-.292.059"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.5 3.75a2.25 2.25 0 0 1 4.5 0v.128q.354-.126.75-.128A2.25 2.25 0 0 1 18 6v.128q.354-.126.75-.128A2.25 2.25 0 0 1 21 8.25v6.568a7.682 7.682 0 0 1-13.934 4.465l-4.62-6.468a2.388 2.388 0 0 1 3.779-2.917l1.275 1.53V6a2.25 2.25 0 0 1 3-2.122zm1.042 10.441A.75.75 0 0 0 12 13.5V3.75a.75.75 0 0 1 1.5 0v9.75a.75.75 0 0 0 1.5 0V6a.75.75 0 0 1 1.5 0v7.5a.75.75 0 0 0 1.5 0V8.25a.75.75 0 0 1 1.5 0v6.568A6.182 6.182 0 0 1 8.287 18.41l-4.62-6.468a.888.888 0 0 1 1.405-1.085l2.602 3.122A.75.75 0 0 0 9 13.5V6a.75.75 0 0 1 1.5-.006V13.5a.75.75 0 0 0 .75.75",
    clipRule: "evenodd"
  })));
};
export default SvgRaiseHand;